// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__3k11m"};